var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCupsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 231,
    viewBox: "0 0 274 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.997 40.8002L147.006 -149H126.989L136.997 40.8002Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.222 -147.183L129.326 41.4708L86.5099 -143.706L106.222 -147.183Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.885 43.4675L66.3729 -138.311L47.562 -131.465L121.885 43.4675Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6663 -122.653L114.899 46.7202L11.3317 -112.644L28.6663 -122.653Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.74798 -100.689L108.589 51.1389L-21.0809 -87.8234L-5.74798 -100.689Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.49 -143.706L144.674 41.4708L167.779 -147.183L187.49 -143.706Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.115 43.4675L226.438 -131.465L207.627 -138.311L152.115 43.4675Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.668 -112.644L159.101 46.7202L245.334 -122.653L262.668 -112.644Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.411 51.1389L295.076 -87.8234L279.743 -100.689L165.411 51.1389Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.689 -57.748L170.861 56.5886L309.818 -73.0809L322.689 -57.748Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28 62.8989L344.653 -23.3339L334.644 -40.6686L175.28 62.8989Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.311 14.3729L178.532 69.8848L353.465 -4.43797L360.311 14.3729Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.529 77.326L369.184 54.2215L365.706 34.5099L180.529 77.326Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 95.006L181.2 84.9975L371 74.9891V95.006Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.529 92.674L365.706 135.49L369.184 115.779L180.529 92.674Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.465 174.438L178.532 100.115L360.311 155.627L353.465 174.438Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28 107.101L334.644 210.669L344.653 193.334L175.28 107.101Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.818 243.076L170.861 113.411L322.689 227.743L309.818 243.076Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.6892 227.743L103.139 113.411L-35.8233 243.076L-48.6892 227.743Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7204 107.101L-70.6526 193.334L-60.6441 210.669L98.7204 107.101Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.3108 155.627L95.4677 100.115L-79.465 174.438L-86.3108 155.627Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4707 92.674L-95.1835 115.779L-91.7056 135.49L93.4707 92.674Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97 74.9891L92.8002 84.9975L-97 95.006V74.9891Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4707 77.326L-91.7056 34.5099L-95.1835 54.2215L93.4707 77.326Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-79.465 -4.43797L95.4677 69.8848L-86.3108 14.3729L-79.465 -4.43797Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7204 62.8989L-60.6441 -40.6686L-70.6526 -23.3339L98.7204 62.8989Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.8233 -73.0809L103.139 56.5886L-48.6892 -57.748L-35.8233 -73.0809Z",
    fill: "#F47B04"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupsBg);
export default __webpack_public_path__ + "static/media/cups_bg.52a04d50bbdd46f73821170380a15a06.svg";
export { ForwardRef as ReactComponent };